import React from 'react'

import { RemoveRowAction, DeleteRowAction } from '@front/squirtle/components/FormTable/Actions/'

const ButtonComponent = ({ rowId, onDelete, ...props }) =>
  rowId === '_create' ? <RemoveRowAction icon='delete' /> : <DeleteRowAction onClick={onDelete} />

export default React.memo(ButtonComponent)
